/** Crew archetype router — picks 1 of 7 dashboards for the newly
 *  signed-up wizard user, or returns null if the user has no wizard
 *  fields (legacy signups fall through to the generic <Dashboard/>).
 *
 *  Consumed by <OrgDashboardRouter/>. Adding a new archetype = add
 *  entry to archetypes.js + mapping in archetypeMap.js — no changes
 *  needed here.
 */
import { useAuth } from "@/contexts/AuthContext";
import { ARCHETYPES } from "./archetypes";
import { pickArchetype } from "./archetypeMap";
import CrewShell from "./CrewShell";

export default function CrewArchetypeRouter() {
  const { user } = useAuth();
  const key = pickArchetype(user);
  if (!key || !ARCHETYPES[key]) return null;
  return <CrewShell archetype={ARCHETYPES[key]} />;
}
